<template>
  <div>
    <BaseCard
      class="radius-8 px-4 cursor-pointer"
      :class="{ 'grey-border': $vuetify.breakpoint.mdAndDown }"
    >
      <template #header>
        <div class="d-flex py-4">
          <BaseThumbnail class="mr-4" :icon="icon" />
          <div class="d-flex flex-column">
            <BaseSubheader class="mb-md-1">
              <span class="brand-primary--text text--tone-400">
                {{ title }}
              </span>
            </BaseSubheader>
            <v-spacer v-if="chipText"/>
            <BaseChip
              v-if="chipText"
              class="text-label-m py-1 px-2"
              :class="[chipAdditionalClasses, {'text--tone-400': $vuetify.breakpoint.mdAndUp}]"
            >
              <template #label>
                <div>
                  {{ chipText }}
                </div>
              </template>
            </BaseChip>
          </div>
        </div>
      </template>
      <template #content>
        <div class="d-md-flex">
          <slot />
        </div>
      </template>
    </BaseCard>
  </div>
</template>

<script>
import BaseCard from '@/components/BaseCard.vue';
import BaseChip from '@/components/BaseChip.vue';
import BaseSubheader from '@/components/BaseSubheader.vue';
import BaseThumbnail from '@/components/BaseThumbnail.vue';

export default {
  components: {
    BaseCard,
    BaseChip,
    BaseSubheader,
    BaseThumbnail,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    chipText: {
      type: String,
      default: null,
    },
    chipAdditionalClasses: {
      type: String,
      default: 'brand-secondary tone-100 brand-secondary--text',
    },
  },
};
</script>

<style lang="scss" scoped>

  .box {
    min-width: 64px;
    min-height: 64px;
  }

  .grey-border {
    border: 1px solid var(--v-neutral-tone-200);
  }

  .radius-8 {
    border-radius: 8px;
  }

  .cursor-pointer {
    cursor: pointer;
  }
</style>
